<template>
  <div>
    <el-dialog
    :append-to-body="true"
      :title="status?'查看按钮':'编辑按钮'"
      :visible.sync="editDialogVisible"
       :close-on-click-modal="false"
      width="30%"
      :before-close="closeEditDialog">
       <el-form resetFields label-width="80px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="按钮名称" prop="buttonName">
          <el-input v-model.trim="form.buttonName" autocomplete="off" placeholder="请输入按钮名称"></el-input>
        </el-form-item>
        <el-form-item label="按钮标识" prop="buttonValue">
          <el-input v-model.trim="form.buttonValue" autocomplete="off" placeholder="请输入按钮标识"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">关 闭</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="status===false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { editBtns, getBtns } from '@/api/buttons'
export default {
  props: {
    editDialogVisible: {
      type: Boolean,
      default: false
    },
    btnId: {
      type: Number
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {},
      rules: {
        buttonName: [
          { required: true, message: '按钮名成不能为空', trigger: 'blur' }
        ],
        buttonValue: [
          { required: true, message: '按钮标识不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getBtnData()
  },
  mounted () {
  },
  methods: {
    getBtnData () {
      getBtns(this.btnId).then((res) => {
        this.form = Object.assign({}, res.data.data)
      })
    },
    closeEditDialog () {
      this.$emit('closeEditDialog')
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(this.form)
          const params = {
            buttonId: this.btnId,
            buttonName: this.form.buttonName,
            buttonValue: this.form.buttonValue,
            remark: this.form.remark
          }
          editBtns(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              console.log(1)
              this.$message({
                type: 'success',
                message: '更新成功'
              })
              this.$emit('closeEditDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>

</style>
